export class Multilingua {
  public uuid: string;

  public tipo: string;

  public it: string;
  public it_name: string;
  public it_keywords: string;
  public it_title: string;
  public it_description: string;

  public eng: string;
  public eng_name: string;
  public eng_keywords: string;
  public eng_title: string;
  public eng_description: string;

  public pt: string;
  public pt_name: string;
  public pt_keywords: string;
  public pt_title: string;
  public pt_description: string;

  constructor() {}
}
